import { Box, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import logoDarkUrl from '../assets/logo-dark.svg';
import logoUrl from '../assets/logo.svg';

/**
 * The company mark.
 *
 * The SVG itself, not a rendering of it: the panel is read on desktop screens
 * of every density and the mark is lettering, which is the thing that goes
 * soft first. The mobile app cannot do this — React Native draws no SVG
 * without another native dependency — so it carries PNGs generated from this
 * same file.
 *
 * Two files, because the mark is red **and** a dark grey, and that grey is
 * barely two to one against the dark theme's bar — the "EXPORT IMPORT S.R.L."
 * line under the name simply disappears. The dark copy lifts the grey and
 * leaves the red exactly as it is: the red is the mark, and tinting a logo to
 * suit a background is where brands start to drift.
 */
export function Logo({ height = 32 }: { height?: number }) {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Box
      component="img"
      src={theme.palette.mode === 'dark' ? logoDarkUrl : logoUrl}
      alt={t('app.name')}
      sx={{ height, width: 'auto', display: 'block' }}
    />
  );
}
